import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCropSummaryTeaReport } from './Pages/listing';

export const DailyCropSummaryTeaReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyCropSummaryTeaReport} />
    </Fragment>
)